// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';
function PartSelectionModal({ show, onClose, parts, onSelectPart, stockCategoryList, CategoryID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const tableRef = useRef();
    const [selectedRows, setSelectedRows] = useState([]);
    const [specialPrices, setSpecialPrices] = useState({});
    const [formData, setFormData] = useState({ FK_Stock_Category_ID: CategoryID });
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }

        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },

            lengthChange: false,
            initComplete: function () {
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };

    useEffect(() => {
        if (parts.length > 0) {
            initDataTable();
        }
    }, [parts]);
    const handleRowClick = (event, part) => {
        const CategoryID = formData.FK_Stock_Category_ID;

        if (CategoryID > 0) {

            const selectedPart = {
                ...part,
                SpecialPrice:
                    specialPrices[part.PK_Stock_ID] !== undefined &&
                        specialPrices[part.PK_Stock_ID] !== ""
                        ? specialPrices[part.PK_Stock_ID]
                        : part.mon_SalesPrice
            };

            onSelectPart(event, selectedPart, CategoryID);
            onClose();
        } else {
            Swal.fire(
                'Error!',
                'Please select discount category.',
                'error'
            );
        }
    };
    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleSpecialPriceChange = (partId, value) => {
        setSpecialPrices(prev => ({
            ...prev,
            [partId]: value
        }));
    };
    const handleCheckboxChange = (part) => {
        setSelectedRows((prev) => {
            const exists = prev.find(p => p.PK_Stock_ID === part.PK_Stock_ID);

            if (exists) {
                return prev.filter(p => p.PK_Stock_ID !== part.PK_Stock_ID);
            }

            return [...prev, part];
        });
    };
    const handleSubmit = (event) => {

        const CategoryID = formData.FK_Stock_Category_ID;

        if (CategoryID <= 0) {
            Swal.fire(
                'Error!',
                'Please select discount category.',
                'error'
            );
            return;
        }

        if (selectedRows.length === 0) {
            Swal.fire(
                'Error!',
                'Please select at least one part.',
                'error'
            );
            return;
        }

        const selectedParts = selectedRows.map(part => ({
            ...part,
            SpecialPrice:
                specialPrices[part.PK_Stock_ID] ??
                part.mon_SalesPrice
        }));

        onSelectPart(event, selectedParts, CategoryID);
        onClose();
    };
    
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none', "marginTop": "50px" }} tabIndex="-1" aria-labelledby="partModalLabel" aria-hidden={!show}>
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-header" onStart={handleStart}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="partModalLabel">Select Part</h5>
                            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">

                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th className="no-wrap">Product Code</th>
                                            <th className="no-wrap">Description</th>
                                            <th className="no-wrap">Sales Price</th>
                                            <th className="no-wrap">Cost Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            parts.map(part => {

                                                const checked = selectedRows.some(
                                                    p => p.PK_Stock_ID === part.PK_Stock_ID
                                                );

                                                return (
                                                    <tr key={part.PK_Stock_ID}>

                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={checked}
                                                                onChange={() => handleCheckboxChange(part)}
                                                            />
                                                        </td>

                                                        <td>{part.vc_StockCode}</td>

                                                        <td>{truncateText(part.vc_Description)}</td>

                                                        <td>{part.mon_SalesPrice}</td>

                                                         <td>{part.mon_StockPrice}</td>

                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                <i className="icofont-save" aria-hidden="true"> Save</i>
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                 <i className="icofont-close" aria-hidden="true"> Close</i>
                            </button>

                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default PartSelectionModal;
